class loginAuth {
  constructor(
    operId,
    login,
    name,
    level,
    order,
    roleId,
    email,
    accessToken,
    refreshToken,
    auditRegis,
    paInicioAsegId,
    active2fa
  ) {
    this.operId = operId;
    this.login = login;
    this.name = name;
    this.level = level;
    this.order = order;
    this.roleId = roleId;
    this.email = email;
    this.accessToken = accessToken;
    this.refreshToken = refreshToken;
    this.auditRegis = auditRegis;
    this.paInicioAsegId = paInicioAsegId;
    this.active2fa = active2fa;
  }

  static fromJson({
    operId,
    login,
    nombre,
    nivel,
    orden,
    roleId,
    correoE,
    accessToken,
    refreshToken,
    auditRegis,
    paInicioAsegId,
    active2fa,
  }) {
    return new loginAuth(
      operId,
      login,
      nombre,
      nivel,
      orden,
      roleId,
      correoE,
      accessToken,
      refreshToken,
      auditRegis,
      paInicioAsegId,
      active2fa
    );
  }
}
export default loginAuth;
